<template>
  <!-- testimonials section -->
  <section class="testimonials pb-lg-5">
    <!-- bg image -->
    <img
      src="@/assets/images/testimonials-bg-new.svg"
      alt="testimonials bg"
      class="testimonials__bg"
    />
    <!-- end bg image -->

    <div class="container pt-5">
      <div class="col-xl-10 mx-auto px-0">
        <div class="row">
          <div class="col-md-6">
            <div>
              <div class="testimonials__heading d-flex align-items-start mb-5">
                <svg
                  width="150"
                  height="auto"
                  viewBox="0 0 185 155"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  data-aos="fade-right"
                  data-aos-offset="1500"
                >
                  <path
                    d="M182.261 23.3283C155.579 36.6817 141.437 52.6921 141.437 71.6161V73.4012L143.211 73.6032C154.581 74.898 163.902 79.4607 171.281 87.2784C178.67 95.1075 182.319 104.093 182.319 114.317C182.319 125.264 178.749 134.399 171.63 141.851C164.532 149.281 155.638 153 144.8 153C132.695 153 122.2 148.177 113.231 138.353C104.275 128.544 99.7857 116.65 99.7857 102.549C99.7857 60.3187 123.329 27.0143 171.21 2.66352L182.261 23.3283ZM84.4522 23.3324C57.5678 36.6807 43.3105 52.6871 43.3105 71.6161V73.405L45.0885 73.6037C56.6942 74.9004 66.1241 79.4687 73.4953 87.2784C80.8847 95.1075 84.5329 104.093 84.5329 114.317C84.5329 125.255 80.913 134.386 73.6844 141.84C66.4687 149.28 57.512 153 46.6733 153C34.5696 153 24.1359 148.178 15.2828 138.362C6.43711 128.555 2 116.657 2 102.549C2 60.311 25.4405 27.0061 73.1046 2.65712L84.4522 23.3324Z"
                    stroke="url(#paint0_linear_734_1791)"
                    stroke-width="4"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_734_1791"
                      x1="92.5"
                      y1="0"
                      x2="92.5"
                      y2="155"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#9672FF" />
                      <stop offset="1" stop-color="#6B4FE8" />
                    </linearGradient>
                  </defs>
                </svg>
                <div class="testimonials__heading__wrapper">
                  <h2
                    class="testimonials__heading__title page-heading"
                    data-aos="fade-up"
                    data-aos-delay="300"
                    data-aos-offset="0"
                  >
                    What Players Say
                  </h2>
                </div>
              </div>

              <TestimonialsCard
                :testimonial="testimonials[0]"
                data-aos="fade-up"
              />
            </div>
          </div>

          <div class="col-md-6">
            <div class="testimonials__list">
              <TestimonialsCard
                v-for="testimonial in testimonials.slice(1)"
                :key="testimonial.id"
                :testimonial="testimonial"
                data-aos="fade-up"
                data-aos-delay="300"
                data-aos-offset="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- end testimonials section -->
</template>

<script>
import TestimonialsCard from "@/components/home/TestimonialsCard.vue";
export default {
  name: "testimonials",
  components: { TestimonialsCard },
  data() {
    return {
      testimonials: [
        {
          id: 1,
          imgName: "1.svg",
          name: "Jesper Wecksell",
          title: "Player, Fanatic Team",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        },
        {
          id: 2,
          imgName: "2.svg",
          name: "Matthea Wünsch",
          title: "Manager, Team Liquid",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.",
        },
        {
          id: 3,
          imgName: "3.svg",
          name: "Wang Chunyu",
          title: "Leader, LGD Gaming",
          desc: "365 games gave us a new genereatio of gaming",
        },
      ],
    };
  },
};
</script>
